import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'

import { Observable, map, of } from 'rxjs'

import {
  FileExtension,
  FileMimeType,
  FileUploadConfig,
} from '@flowx/designer/modules/new-ai/common/ai.dictionary'
import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

import { AiDocumentsTransformService } from '../../agents/documents/services/ai-documents-transform.service'

@Injectable({
  providedIn: 'root',
})
export class AiInitApi extends ApiHttpService {
  constructor(@Inject('BASE_URL') baseUrl: string, httpClient: HttpClient) {
    super(baseUrl, httpClient)
  }

  init(): Observable<FileUploadConfig> {
    return of({
      imageUpload: {
        fileType: [FileMimeType.PNG, FileMimeType.JPEG, FileMimeType.JPG],
        maxFileSize: 3 * 1024 * 1024,
        maxFileNumber: 1,
      },
      bpmnUpload: {
        fileType: [FileExtension.BPMN],
        maxFileSize: 3 * 1024 * 1024,
        maxFileNumber: 1,
      },
      documentUpload: {
        fileType: [
          FileMimeType.PDF,
          FileExtension.DOCX,
          FileExtension.MARKDOWN,
          FileExtension.TEXT,
        ],
        maxFileSize: 15 * 1024 * 1024,
        maxFileNumber: 1,
      },
      processUpload: {
        fileType: [FileExtension.BPMN, FileExtension.XML],
        maxFileSize: 3 * 1024 * 1024,
        maxFileNumber: 1,
      },
    }).pipe(map(AiDocumentsTransformService.configResponseTransform))
  }
}
